var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatBubbleNotificationFill = function SvgChatBubbleNotificationFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_icon_chatbubblenotificationfill__clip0_2530_29047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 16 3q0-1.25.875-2.125A2.9 2.9 0 0 1 19 0q1.25 0 2.125.875T22 3t-.875 2.125A2.9 2.9 0 0 1 19 6M6 18l-2.3 2.3q-.476.475-1.088.212Q2 20.25 2 19.575V4q0-.824.587-1.412A1.93 1.93 0 0 1 4 2h10.1a5.1 5.1 0 0 0 0 2q.35 1.725 1.725 2.863A4.84 4.84 0 0 0 19 8a5.1 5.1 0 0 0 1.575-.25A4.7 4.7 0 0 0 22 7v9q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_icon_chatbubblenotificationfill__clip0_2530_29047"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatBubbleNotificationFill);
export { ForwardRef as ReactComponent };